export const availableCategories = [
  "world",
  "uzbekistan",
  'science',
  "politics",
  "lifestyle",
  "medicine",
  "society",
  "sport",
  'media',
  'hi-tech',
];

export const darkCats = [
  'hi-tech'
]

export const regions = [
  "karakalpakistan",
  "khorezm",
  "navoi",
  "bukhara",
  "samarkand",
  "karshi",
  "jizzax",
  "surkhandarya",
  "sirdarya",
  "tashkent",
  "namangan",
  "fergana",
  "andijan"
];

// tg channels for all languages
export const CHANNELS = {
  en: "zamonuzeng",
  ru: "zamonuzru",
  uz: "zamonuz",
  "uz-to": "zamonuzb"
};

// SEO
export const DESCRIPTIONS = {
  en:
    "Latest news happened in Uzbekistan and around the world. A news aggregator for the modern age. ",
  ru:
    "Последние новости происходили в Узбекистане и по всему миру. Агрегатор новостей для современной эпохи. ",
  uz:
    "So'nggi yangiliklar O'zbekistonda va butun dunyoda bo'lib o'tdi. Zamonaviy davr uchun yangiliklar agregatori. ",
  "uz-to":
    "Енг сўнгги янгиликлар Ўзбекистонда ва бутун дунёда бўлиб ўтди. Замонавий давр учун янгиликлар aggregator. "
};
export const KEYWORDS =
  "yangilik, yangiliklar, yangiliklari, янгилик, янгиликлар, ozbekiston yangiliklari, uzbekistan, uzbek, news, news aggregator, uzbekistan news, uzbek news, uzbekistan news aggregator, uzbekistan, uzbek, zamon, zamon yangiliklar, замон новости, замон, новости узбекистана, узбекистан, zamon";

export const categories = [
  {
    name_en: "World",
    name_ru: "Мир",
    name_uz: "Dunyo",
    "name_uz-to": "Дунё",
    slug: "world"
  },
  {
    name_en: "Uzbekistan",
    name_ru: "Узбекистан",
    name_uz: "O'zbekiston",
    "name_uz-to": "Ўзбекистон",
    slug: "uzbekistan"
  },
  {
    name_en: "Science",
    name_ru: "Наука",
    name_uz: "Ilm",
    "name_uz-to": "Илм",
    slug: "science"
  },
  {
    name_en: "Politics",
    name_ru: "Политика",
    name_uz: "Siyosat",
    "name_uz-to": "Сиёсат",
    slug: "politics"
  },
  {
    name_en: "Lifestyle",
    name_ru: "Lifestyle",
    name_uz: "Lifestyle",
    "name_uz-to": "Lifestyle",
    slug: "lifestyle"
  },
  {
    name_en: "Medicine",
    name_ru: "Медицина",
    name_uz: "Tibbiyot",
    "name_uz-to": "Тиббиёт",
    slug: "medicine"
  },
  {
    name_en: "Society",
    name_ru: "Общество",
    name_uz: "Jamiyat",
    "name_uz-to": "Жамият",
    slug: "society"
  },
  {
    name_en: "Sport",
    name_ru: "Спорт",
    name_uz: "Sport",
    "name_uz-to": "Спорт",
    slug: "sport"
  },
  {
    name_en: "Media",
    name_ru: "Медиа",
    name_uz: "Media",
    "name_uz-to": "Медиа",
    slug: "media"
  },
  {
    name_en: "Hi-Tech",
    name_ru: "Hi-Tech",
    name_uz: "Hi-Tech",
    "name_uz-to": "Hi-Tech",
    slug: "hi-tech"
  }
];

export const fakeArticle = {
  id: -1,
  title:
    "Training standard standard standard standard standard standard stuff their be young budget executive.",
  brief: "",
  description:
    "Remain fly indicate heavy but near husband. Million whether most future. Go visit more project fine risk. High evening yes rich PM where concern. Former health get result. Quite standard close financial appear nature quite every. Window act morning everybody than before real. Order should off specific through return we anyone. Identify feel time meet. Support brother ground may TV. Others bar feeling analysis such avoid. Fish vote woman cup. Against black night soldier. Carry image collection gas also door. Effort treat adult. Traditional cold quickly program idea activity. Until decision society chair board once crime. Company kid hard these. Outside control meet throughout why. Including mouth skin few method. Today more five option. Tv impact your sort recognize series blue. Start plan election site indicate stage. Likely also until. Easy whatever manager finish part market. Collection film represent enter despite. Environmental out tree worker. Third report system. Newspaper structure open ever meeting. To sort face main feeling. Maybe public medical history teacher. Interesting peace family pattern. Else practice tell. Market one call recently. Lose stuff stay building.",
  author: {
    id: -1,
    username: "Author",
    name: "Author",
    surname: "Author"
  },
  sub_category: {
    name: "Medicine",
    slug: "medicine-medicine",
    category: {
      name: "Medicine",
      slug: "medicine"
    }
  },
  tags: "",
  image: {
    large: "",
    thumbnail: "",
    medium: "",
    original: ""
  },
  video: null,
  view_count: 35,
  pub_date: "2021-02-09T00:00:00+05:00",
  recommendation: [
    {
      id: 72,
      url: "asdsa",
      title:
        "Instead Instead Instead much peace according meet appear major push.",
      sub_category: {
        name: "Society",
        slug: "society-society",
        category: {
          name: "Society",
          slug: "society"
        }
      },
      image: {
        large: "",
        thumbnail: "",
        medium: "",
        original: "https://zamon.al-electronics.uz/media/fake_img/1.jpg"
      },
      pub_date: "2021-04-05T00:00:00+05:00"
    },
    {
      id: 17,
      url: "coach-fly-yeah-ahead-world",
      title: "Instead much peace according meet appear major push.",
      sub_category: {
        name: "World",
        slug: "world-world",
        category: {
          name: "World",
          slug: "world"
        }
      },
      image: {
        large: "https://zamon.al-electronics.uz/media/fake_img/6.large.jpg",
        thumbnail:
          "https://zamon.al-electronics.uz/media/fake_img/6.thumbnail.jpg",
        medium: "https://zamon.al-electronics.uz/media/fake_img/6.medium.jpg",
        original: "https://zamon.al-electronics.uz/media/fake_img/6.jpg"
      },
      pub_date: "2021-04-16T00:00:00+05:00"
    },
    {
      id: 44,
      url: "toward-one-ahead-difficult-live-smile-politics",
      title: "Instead much peace according meet appear major push.",
      sub_category: {
        name: "Politics",
        slug: "politics-politics",
        category: {
          name: "Politics",
          slug: "politics"
        }
      },
      image: {
        large: "https://zamon.al-electronics.uz/media/fake_img/3.large.jpg",
        thumbnail:
          "https://zamon.al-electronics.uz/media/fake_img/3.thumbnail.jpg",
        medium: "https://zamon.al-electronics.uz/media/fake_img/3.medium.jpg",
        original: "https://zamon.al-electronics.uz/media/fake_img/3.jpg"
      },
      pub_date: "2021-01-01T00:00:00+05:00"
    },
    {
      id: 85,
      url: "challenge-wide-ability-glass-staff-join-sport",
      title: "Instead much peace according meet appear major push.",
      sub_category: {
        name: "Sport",
        slug: "sport-sport",
        category: {
          name: "Sport",
          slug: "sport"
        }
      },
      image: {
        large: "https://zamon.al-electronics.uz/media/fake_img/4.large.jpg",
        thumbnail:
          "https://zamon.al-electronics.uz/media/fake_img/4.thumbnail.jpg",
        medium: "https://zamon.al-electronics.uz/media/fake_img/4.medium.jpg",
        original: "https://zamon.al-electronics.uz/media/fake_img/4.jpg"
      },
      pub_date: "2021-01-25T00:00:00+05:00"
    }
  ]
};

export const concurrency_rating = {
  ru: {
    Сингапур: "84.8",
    США: "83.7",
    Гонконг: "83.1",
    "Нидер­ланды": "82.4",
    "Швей­цария": "82.3",
    Япония: "82.3",
    Германия: "81.8",
    Швеция: "81.2",
    "Велико­британия": "81.2",
    Дания: "81.2",
    "Финлян­дия": "80.2",
    Тайвань: "80.2",
    "Южная Корея": "79.6",
    Канада: "79.6",
    Франция: "78.8",
    "Австра­лия": "78.7",
    Норвегия: "78.1",
    "Люксем­бург": "77.0",
    "Новая Зелан­дия": "76.7",
    Израиль: "76.7",
    Австрия: "76.6",
    Бельгия: "76.4",
    Испания: "75.3",
    Ирландия: "75.1",
    ОАЭ: "75.0",
    Исландия: "74.7",
    "Малай­зия": "74.6",
    Китай: "73.9",
    Катар: "72.9",
    Италия: "71.5",
    Эстония: "70.9",
    Чехия: "70.9",
    Чили: "70.5",
    "Порту­галия": "70.4",
    Словения: "70.2",
    "Саудов­ская Аравия": "70.0",
    Польша: "68.9",
    Мальта: "68.5",
    Литва: "68.4",
    Таиланд: "68.1",
    Латвия: "67.0",
    Словакия: "66.8",
    Россия: "66.7",
    Кипр: "66.4",
    Бахрейн: "65.4",
    Кувейт: "65.1",
    Венгрия: "65.1",
    Мексика: "64.9",
    Болгария: "64.9",
    "Индо­незия": "64.6",
    Румыния: "64.4",
    Маврикий: "64.3",
    Оман: "63.6",
    Уругвай: "63.5",
    "Казах­стан": "62.9",
    Бруней: "62.8",
    Колумбия: "62.7",
    "Азербай­джан": "62.7",
    Греция: "62.6",
    ЮАР: "62.4",
    Турция: "62.1",
    "Коста-Рика": "62.0",
    Хорватия: "61.9",
    "Филип­пины": "61.9",
    Перу: "61.7",
    Панама: "61.6",
    Вьетнам: "61.5",
    Индия: "61.4",
    Армения: "61.3",
    Иордания: "60.9",
    "Брази­лия": "60.9",
    Сербия: "60.9",
    Черногория: "60.8",
    Грузия: "60.6",
    Марокко: "60.0",
    "Сейшель­ские о-ва": "59.6",
    Барбадос: "58.9",
    "Домини­кана": "58.3",
    "Трини­дад и Тобаго": "58.3",
    Ямайка: "58.3",
    Албания: "57.6",
    "Маке­дония": "57.3",
    Аргентина: "57.2",
    "Шри-Ланка": "57.1",
    Украина: "57.0",
    Молдова: "56.7",
    Тунис: "56.4",
    Ливан: "56.3",
    Алжир: "56.3",
    Эквадор: "55.7",
    Ботсвана: "55.5",
    "Босния и Герцего­вина": "54.7",
    Египет: "54.5",
    Намибия: "54.5",
    Кения: "54.1",
    Киргизия: "54.0",
    Парагвай: "53.6",
    "Гвате­мала": "53.5",
    Иран: "53.0",
    Руанда: "52.8",
    Гондурас: "52.6",
    Монголия: "52.6",
    "Сальва­дор": "52.6",
    "Таджики­стан": "52.4",
    "Бангла­деш": "52.1",
    Камбоджа: "52.1",
    Боливия: "51.8",
    Непал: "51.6",
    Никарагуа: "51.5",
    Пакистан: "51.4",
    Гана: "51.2",
    "Кабо-Верде": "50.8",
    Лаос: "50.1",
    Сенегал: "49.7",
    Уганда: "48.9",
    Нигерия: "48.3",
    Танзания: "48.2",
    "Кот-д’Ивуар": "48.1",
    Габон: "47.5",
    Замбия: "46.5",
    "Свази­ленд": "46.4",
    Гвинея: "46.1",
    Камерун: "46.0",
    Гамбия: "45.9",
    Бенин: "45.8",
    Эфиопия: "44.4",
    Зимбабве: "44.2",
    Малави: "43.7",
    Мали: "43.6",
    "Буркина-Фасо": "43.4",
    Лесото: "42.9",
    "Мада­гаскар": "42.9",
    "Вене­суэла": "41.8",
    "Маври­тания": "40.9",
    Бурунди: "40.3",
    Ангола: "38.1",
    Мозамбик: "38.1",
    Гаити: "36.3",
    "ДР Конго": "36.1",
    Йемен: "35.5",
    Чад: "35.1"
  }
};

export const countries = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algeria",
  AO: "Angola",
  AQ: "Antarctica",
  AR: "Argentina",
  AM: "Armenia",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BD: "Bangladesh",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia And Herzegovina",
  BW: "Botswana",
  BR: "Brazil",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CO: "Colombia",
  CG: "Congo",
  CD: "Congo",
  CR: "Costa Rica",
  CI: "Cote D'Ivoire",
  HR: "Croatia",
  CU: "Cuba",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DK: "Denmark",
  DJ: "Djibouti",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GR: "Greece",
  GL: "Greenland",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HN: "Honduras",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran",
  IQ: "Iraq",
  IE: "Ireland",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KP: "North Korea",
  KR: "South Korea",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Laos",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LT: "Lithuania",
  LU: "Luxembourg",
  MK: "Macedonia",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  ML: "Mali",
  MR: "Mauritania",
  MX: "Mexico",
  MD: "Moldova",
  MN: "Mongolia",
  ME: "Montenegro",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NP: "Nepal",
  NL: "Netherlands",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RO: "Romania",
  RU: "Russia",
  RW: "Rwanda",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SL: "Sierra Leone",
  SK: "Slovakia",
  SI: "Slovenia",
  SO: "Somalia",
  ZA: "South Africa",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SS: "South Sudan",
  SR: "Suriname",
  SZ: "Swaziland",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syria",
  TW: "Taiwan",
  TJ: "Tajikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TG: "Togo",
  TT: "Trinidad And Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VE: "Venezuela",
  VN: "Viet Nam",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe"
};

export const staffCountries = [
  "AF,33,65",
  "AL,41,20",
  "DZ,28,3",
  "AD,42.5,1.6",
  "AO,-12.5,18.5",
  "AQ,-90,0",
  "AR,-34,-64",
  "AM,40,45",
  "AU,-27,133",
  "AT,47.3333,13.3333",
  "AZ,40.5,47.5",
  "BS,24.25,-76",
  "BH,26,50.55",
  "BD,24,90",
  "BY,53,28",
  "BE,50.8333,4",
  "BZ,17.25,-88.75",
  "BJ,9.5,2.25",
  "BM,32.3333,-64.75",
  "BT,27.5,90.5",
  "BO,-17,-65",
  "BA,44,18",
  "BW,-22,24",
  "BR,-10,-55",
  "BG,43,25",
  "BF,13,-2",
  "BI,-3.5,30",
  "KH,13,105",
  "CM,6,12",
  "CA,60,-95",
  "CF,7,21",
  "TD,15,19",
  "CL,-30,-71",
  "CN,35,105",
  "CO,4,-72",
  "CG,-1,15",
  "CR,10,-84",
  "CI,8,-5",
  "HR,45.1667,15.5",
  "CU,21.5,-80",
  "CY,35,33",
  "CZ,49.75,15.5",
  "DK,56,10",
  "DJ,11.5,43",
  "DO,19,-70.6667",
  "EC,-2,-77.5",
  "EG,27,30",
  "SV,13.8333,-88.9167",
  "GQ,2,10",
  "ER,15,39",
  "EE,59,26",
  "ET,8,38",
  "FI,64,26",
  "FR,46,2",
  "GA,-1,11.75",
  "GM,13.4667,-16.5667",
  "GE,42,43.5",
  "DE,51,9",
  "GH,8,-2",
  "GI,36.1833,-5.3667",
  "GR,39,22",
  "GL,72,-40",
  "GD,12.1167,-61.6667",
  "GP,16.25,-61.5833",
  "GT,15.5,-90.25",
  "GN,11,-10",
  "GW,12,-15",
  "GY,5,-59",
  "HT,19,-72.4167",
  "HN,15,-86.5",
  "HK,22.25,114.1667",
  "HU,47,20",
  "IS,65,-18",
  "IN,20,77",
  "ID,-5,120",
  "IR,32,53",
  "IQ,33,44",
  "IE,53,-8",
  "IL,31.5,34.75",
  "IT,42.8333,12.8333",
  "JM,18.25,-77.5",
  "JP,36,138",
  "JO,31,36",
  "KZ,48,68",
  "KE,1,38",
  "KP,40,127",
  "KR,37,127.5",
  "KW,29.3375,47.6581",
  "KG,41,75",
  "LA,18,105",
  "LV,57,25",
  "LB,33.8333,35.8333",
  "LS,-29.5,28.5",
  "LR,6.5,-9.5",
  "LY,25,17",
  "LT,56,24",
  "LU,49.75,6.1667",
  "MO,22.1667,113.55",
  "MK,41.8333,22",
  "MG,-20,47",
  "MW,-13.5,34",
  "MY,2.5,112.5",
  "MV,3.25,73",
  "ML,17,-4",
  "MR,20,-12",
  "MX,23,-102",
  "MD,47,29",
  "MC,43.7333,7.4",
  "MN,46,105",
  "ME,42,19",
  "MA,32,-5",
  "MZ,-18.25,35",
  "MM,22,98",
  "NA,-22,17",
  "NP,28,84",
  "NL,52.5,5.75",
  "NZ,-41,174",
  "NI,13,-85",
  "NE,16,8",
  "NG,10,8",
  "NO,62,10",
  "OM,21,57",
  "PK,30,70",
  "PA,9,-80",
  "PG,-6,147",
  "PY,-23,-58",
  "PE,-10,-76",
  "PH,13,122",
  "PL,52,20",
  "PT,39.5,-8",
  "PR,18.25,-66.5",
  "QA,25.5,51.25",
  "RO,46,25",
  "RU,60,100",
  "RW,-2,30",
  "WS,-13.5833,-172.3333",
  "SA,25,45",
  "SN,14,-14",
  "RS,44,21",
  "SL,8.5,-11.5",
  "SG,1.3667,103.8",
  "SK,48.6667,19.5",
  "SI,46,15",
  "SO,10,49",
  "ZA,-29,24",
  "ES,40,-4",
  "LK,7,81",
  "SD,15,30",
  "SR,4,-56",
  "SZ,-26.5,31.5",
  "SE,62,15",
  "CH,47,8",
  "SY,35,38",
  "TW,23.5,121",
  "TJ,39,71",
  "TZ,-6,35",
  "TH,15,100",
  "TG,8,1.1667",
  "TO,-20,-175",
  "TN,34,9",
  "TR,39,35",
  "TM,40,60",
  "UG,1,32",
  "UA,49,32",
  "AE,24,54",
  "GB,54,-2",
  "US,38,-97",
  "UY,-33,-56",
  "UZ,41,64",
  "VE,8,-66",
  "VN,16,106",
  "YE,15,48",
  "ZM,-15,30",
  "ZW,-20,30"
]
export const staffRegions = [
  'karakalpakstan',
  'khorezm',
  'navoi',
  'bukhara',
  'samarkand',
  'qashqadarya',
  'jizzax',
  'surhandarya',
  'sirdarya',
  'tashkent',
  'namangan',
  'fergana',
  'andijan'
]
